import React from 'react';
import PropTypes from 'prop-types';
import './SsoErrorPage.scss';
import Icon from '../Common/Icon';
import URLSearchParams from '@ungap/url-search-params'; // URLSearchParams polyfill for IE11

export class SsoErrorPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            ssoAttributes: {}
        };
    }

    componentDidMount() {
        this.parseQueryStrings();
    }

    parseQueryStrings = () => {
        const urlParams = new URLSearchParams(this.props.location.search);
        //clear out url params
        this.props.history.push(this.props.history.location.pathname);
        
        this.setState({
            ssoAttributes: urlParams.entries(),
        });
    }

    getMailToString = (params) => {
        if(params.length > 0) {
            let body = "| ";
            params.map( (value) => {
                body += value[0] + "=" + value[1] + " | ";
            })
            return "mailto:support@getpacer.com?subject=SSO Profile Creation Help&body=" + encodeURI(body);
        } else {
            return "mailto:support@getpacer.com"
        }
    }

    render() {
        const ssoAttributesArray = Array.from(this.state.ssoAttributes);
        const supportEmailElement = <a href={this.getMailToString(ssoAttributesArray)}>support@getpacer.com</a>;

        return (
            <div>
                <div className="sso-error-container container">
                    <div className="sso-error-head">

                        <div className="row">
                            <div className="col">
                                <p className="text-center">
                                    <Icon name="exclamation-triangle" />
                                </p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <h5 className="text-center">Unable to create or update a user profile</h5>
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-md-10">
                                <p>
                                    A Land-It user profile was not able to be created or updated for your EID. 
                                    This profile creation/edit process occurs for new users or for existing users 
                                    who have recently had an update to their management company, division, or unit numbers.
                                </p>
                            </div>
                        </div>

                        <div className="row common-reasons justify-content-center">
                            <div className="col-md-10">
                                <h5>Common Reasons Include</h5>
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-md-10">
                                <p>
                                    The location associated with your EID has not yet been created in Land-It; locations are created in Land-It 30-60 days prior to opening.
                                    Your EID data does not include all of the required information. 
                                    Your EID data is associated with an Ownership group instead of a Management Company.
                                    The location’s management company has recently changed and needs to be updated in Land-It.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="sso-error-container container">

                    <div className="row next-steps">
                        <div className="col">
                            <h4 className="text-center">Next Steps</h4>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="card card-step">
                                <div className="card-body">
                                    <h5 className="card-title">If your location is in pre-opening</h5>
                                    <p className="card-text">
                                        Please try to access Land-It again within 30 days of the opening date.
                                    </p>
                                    <p className="card-text">
                                        If you are attempting to login to the pre-opening Critical Path, your username is unlikely to be your EID. 
                                        Most often the username is your email address. If you do not recall your username, click the Forgot Username 
                                        link at <a href=" https://getpacer.com/" target="_blank" rel="noopener noreferrer">https://getpacer.com</a>.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="card card-step">
                                <div className="card-body">
                                    <h5 className="card-title">If the location’s management company has recently changed</h5>
                                    <p className="card-text">
                                        Email {supportEmailElement} with this new information.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="card card-step">
                                <div className="card-body">
                                    <h5 className="card-title">If your EID is assigned to a shared services division/unit</h5>
                                    <p className="card-text">
                                        Email {supportEmailElement} with this information. 
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card card-step">
                                <div className="card-body">
                                    <h5 className="card-title">If the previous three options do not apply to you</h5>
                                    <p className="card-text">
                                        Submit a <a href="https://marriott.service-now.com/msp?id=msp_get_help&sys_id=9fab39e2d7532100a9ad1e173e24d484">SNOW ticket</a> for Land-It support on ServiceNow or email {supportEmailElement} for assistance.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {ssoAttributesArray.length > 0 &&
                    <div className="sso-error-container">
                        <p className='text-center'>Support Team Reference</p>
                        <div className="text-center">
                        {ssoAttributesArray.map( (value, index) => {
                                return <div className="param" key={index}>{value[0]} - {value[1]} </div>
                            })}
                        </div>
                    </div>
                }
            </div>
        );
    }
}

SsoErrorPage.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
}

export default SsoErrorPage;
